export default __webpack_public_path__ + "static/media/css.971acab6.png";